import styled from 'styled-components'
import ErrorImage from '../../assets/Error.png'
import {Button} from '@mui/material'

const Page = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    scroll-behavior: smooth;
    flex: 1;
    background: #f6f8fa;
`
const Title = styled.h1`
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 32px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: center;
    margin-bottom: 16px;
`

const Text = styled.p`
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-size: 18px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: center;
    color: #333;
    margin-bottom: 24px;
    max-width: 600px;
`

export default function Error() {
    return (
        <Page>
            <img src={ErrorImage} alt="Error illustration" />
            <Title>Algo deu errado...</Title>
            <Text>
                Não se preocupe, estamos trabalhando para resolver o mais rápido
                possível. Às vezes até os melhores sistemas tiram um cochilo.
            </Text>
            <Button
                variant="contained"
                color="primary"
                onClick={() => (window.location.href = '/')}
            >
                Voltar para a página inicial
            </Button>
        </Page>
    )
}
